import formatCases from "./formatters/formatCases";

const formatResponse = (resp: Response, data: any) => {
  // console.log('formatResponse', resp, data)

  if (resp?.url.includes("/v2/objections/client/cases")) {
      return formatCases(data)
  }
  return data
}

export default formatResponse
